import { useEffect } from 'react';

import { useProviderDetails } from '../../hooks/useProviderDetails';
import { ProviderType } from '../../models/ProviderDetails';
import {
  getNameAttrs,
  parseProviderName,
} from '../../utils/providerNames.utils';
import {
  CareCategories,
  ReverseCoverageTypesCodes,
  SectionType,
} from '../Constants';

export const ProviderDetailsLoader = ({
  providerId,
  providerType,
  onLoad,
}: {
  providerId: string;
  providerType: string;
  locationId?: string;
  onLoad: (data: any, isLoading: boolean) => void;
}) => {
  const { data, isLoading } = useProviderDetails({
    providerType,
    providerId,
  });

  useEffect(() => {
    onLoad(data, isLoading);
  }, [data, isLoading]);

  return null;
};

export const getNameForToast = (details) => {
  const nameAttrs = getNameAttrs(details);
  const name = parseProviderName(
    details?.providerName,
    details?.providerType as ProviderType,
    details?.primaryDegrees?.[0],
    nameAttrs
  );
  return name;
};

export const deriveChipValueIfMissing = (
  chipValue,
  chipValueParam,
  coverageType,
  sectionType,
  pcpIndicator
) => {
  const derivedChipValue = chipValue || chipValueParam;
  if (derivedChipValue) {
    const chips = derivedChipValue.split(',');
    if (chips.length > 1) {
      let tempChipValue = getChipValueBasedOnCoverageType(
        coverageType,
        sectionType,
        pcpIndicator,
        chips
      );
      if (!tempChipValue) {
        tempChipValue = chips[0];
      }
      return tempChipValue;
    } else {
      return derivedChipValue;
    }
  }
  return getChipValueBasedOnCoverageType(
    coverageType,
    sectionType,
    pcpIndicator
  );
};

export const getChipValueBasedOnCoverageType = (
  coverageType: string = '',
  sectionType,
  pcpIndicator,
  chips: string[] = []
) => {
  if (coverageType) {
    switch (coverageType.substring(0, 1)) {
      case ReverseCoverageTypesCodes['BEHAVIORAL HEALTH']:
        return CareCategories.BEHAVIORAL_HEALTH;
      case ReverseCoverageTypesCodes['DENTAL']:
        return CareCategories.DENTAL;
      case ReverseCoverageTypesCodes['VISION']:
        return CareCategories.VISION;
      default:
        return getMedicalCoveragesChipValue(sectionType, pcpIndicator, chips);
    }
  }
  return '';
};

export const getMedicalCoveragesChipValue = (
  sectionType: string,
  pcpIndicator: boolean,
  chips: string[] = []
) => {
  if (pcpIndicator || chips.includes(CareCategories.PRIMARY_CARE)) {
    return CareCategories.PRIMARY_CARE;
  }
  if (sectionType || chips.length > 1) {
    if (sectionType === SectionType.FACILITY) {
      return CareCategories.FACILITIES;
    }
    return CareCategories.MEDICAL_SPECIALISTS;
  }
  return '';
};
